var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shipping-range-editor" },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "d-flex align-center", attrs: { xs12: "" } },
            [
              _c("v-subheader", [
                _vm._v(_vm._s(_vm.$t("shippingDimensionsAndMaterials")))
              ]),
              _vm._v(" "),
              !_vm.readonly
                ? _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "primary" },
                      on: { click: _vm.addRange }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("add")) + "\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.localRanges, function(range, index) {
        return _c(
          "v-layout",
          { key: index, staticClass: "shipping-range", attrs: { wrap: "" } },
          [
            _c(
              "v-flex",
              { attrs: { xs12: "" } },
              [
                _c(
                  "v-card",
                  { attrs: { flat: "" } },
                  [
                    _c(
                      "v-card-text",
                      { staticClass: "pa-2" },
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              wrap: "",
                              "align-center": "",
                              "pl-3": "",
                              "pr-4": ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs3: "", "pr-2": "" } },
                              [
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "", "pr-1": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("minQuantity"),
                                            dense: "",
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired(
                                                    "minQuantity"
                                                  ),
                                                  _vm.fieldIsOverZero(
                                                    "minQuantity"
                                                  ),
                                                  _vm.fieldIsInteger(
                                                    "minQuantity"
                                                  ),
                                                  _vm.getScopeValidator(
                                                    "min",
                                                    index
                                                  )
                                                ]
                                          },
                                          model: {
                                            value: range.min,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "min",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.min"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "", "pl-1": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("maxQuantity"),
                                            dense: "",
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired(
                                                    "maxQuantity"
                                                  ),
                                                  _vm.fieldIsOverZero(
                                                    "maxQuantity"
                                                  ),
                                                  _vm.fieldIsInteger(
                                                    "maxQuantity"
                                                  ),
                                                  _vm.getScopeValidator(
                                                    "max",
                                                    index
                                                  )
                                                ]
                                          },
                                          model: {
                                            value: range.max,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "max",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.max"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      staticClass: "divider-height",
                                      attrs: { vertical: "" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs9: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "pr-3": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("weight"),
                                            suffix: _vm.weightSuffix,
                                            dense: "",
                                            hint: _vm.$t("avgItemWeight"),
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired("weight"),
                                                  _vm.fieldIsOverZero("weight")
                                                ]
                                          },
                                          model: {
                                            value: range.weight,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "weight",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.weight"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "pr-3": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("L"),
                                            suffix: _vm.sizeSuffix,
                                            dense: "",
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired("length"),
                                                  _vm.fieldIsOverZero("length")
                                                ]
                                          },
                                          model: {
                                            value: range.length,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "length",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.length"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "pr-3": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("W"),
                                            suffix: _vm.sizeSuffix,
                                            dense: "",
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired("width"),
                                                  _vm.fieldIsOverZero("width")
                                                ]
                                          },
                                          model: {
                                            value: range.width,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "width",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.width"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "pr-3": "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("H"),
                                            suffix: _vm.sizeSuffix,
                                            dense: "",
                                            disabled: _vm.readonly,
                                            rules: _vm.readonly
                                              ? []
                                              : [
                                                  _vm.fieldIsRequired("height"),
                                                  _vm.fieldIsOverZero("height")
                                                ]
                                          },
                                          model: {
                                            value: range.height,
                                            callback: function($$v) {
                                              _vm.$set(
                                                range,
                                                "height",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "range.height"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.readonly
                              ? _c(
                                  "v-flex",
                                  { attrs: { xs11: "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.materialFees,
                                                "item-text": "name",
                                                "item-value": "name",
                                                dense: "",
                                                readonly: _vm.readonly,
                                                clearable: "",
                                                "return-object": "",
                                                label: _vm.$t("materialFee"),
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: range.materials[0],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    range.materials,
                                                    0,
                                                    $$v
                                                  )
                                                },
                                                expression: "range.materials[0]"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs3: "" } },
                                          [
                                            !!range.materials &&
                                            !!range.materials[0] &&
                                            !!range.materials[0].name
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    value:
                                                      range.materials[0].price,
                                                    label: _vm.$t("price"),
                                                    readonly: "",
                                                    dense: "",
                                                    prefix: "$"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs2: "" } },
                                          [
                                            !!range.materials &&
                                            !!range.materials[0] &&
                                            !!range.materials[0].name
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    label: _vm.$t("quantity"),
                                                    readonly: _vm.readonly,
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "quantity"
                                                      ),
                                                      _vm.fieldIsOverZero(
                                                        "quantity"
                                                      ),
                                                      _vm.fieldIsInteger(
                                                        "quantity"
                                                      )
                                                    ],
                                                    dense: ""
                                                  },
                                                  model: {
                                                    value:
                                                      range.materials[0]
                                                        .quantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        range.materials[0],
                                                        "quantity",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "range.materials[0].quantity"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { staticClass: "text-right", attrs: { xs1: "" } },
                              [
                                _vm.localRanges.length > 1 && !_vm.readonly
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeRange(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("delete")
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51e56e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e56e7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingRangeEditor.vue
// module id = null
// module chunks = 